import React, { createContext, useContext } from "react";

const EpSessionContext = createContext(null);

export const EpSessionProvider = ({ value, children }) => (
  <EpSessionContext.Provider value={value}>
    {children}
  </EpSessionContext.Provider>
);

export const useEpSession = () => {
  const ctx = useContext(EpSessionContext);
  if (!ctx) {
    throw new Error("useEpSession must be used within an EpSessionProvider");
  }
  return ctx;
};
